import React from "react";
import DateTimePicker from "components/GenericComponent/DateTimePicker";

const SearchForm = ({ listUserName,dataSearch, onChangeData, onChangeDate, onSearch, handleKeyDown }) => (
    <div className="search-new">
        <div className="input-sm-new input-new-18">
            <label htmlFor="sCode" className="font-color-default font-bold">Mã hợp đồng</label>
            <input
                id="sCode"
                type="text"
                className="form-control input-sm"
                placeholder="Mã hợp đồng"
                onChange={onChangeData("sCode")}
                onKeyDown={handleKeyDown}
                value={dataSearch.sCode}
            />
        </div>
        <div className="input-sm-new input-new-18">
            <label htmlFor="sFromDate" className="font-color-default font-bold">Từ ngày</label>
            <DateTimePicker
                id="sFromDate"
                value={dataSearch.sFromDate}
                onChange={onChangeDate("sFromDate")}
                placeholder="Từ ngày"
                name="sFromDate"
            />
        </div>
        <div className="input-sm-new input-new-18">
            <label htmlFor="sToDate" className="font-color-default font-bold">Đến ngày</label>
            <DateTimePicker
                id="sToDate"
                value={dataSearch.sToDate}
                onChange={onChangeDate("sToDate")}
                placeholder="Đến ngày"
                name="sToDate"
            />
        </div>
        <div className="input-sm-new input-new-18">
            <label htmlFor="sType" className="font-color-default font-bold">Phân loại</label>
            <select id="sType" name="sType"
                value={dataSearch.sType}
                onChange={onChangeData("sType")}
                className="form-control input-sm">
                <option value="">Tất cả</option>
                <option value="51">Nhập quỹ</option>
                <option value="50">Chuyển quỹ</option>
                <option value="52">Rút quỹ</option>
            </select>
        </div>
        <div className="input-sm-new input-new-18">
            <label htmlFor="sUserName" className="font-color-default font-bold">Nhân viên</label>
            <select id="sUserName" name="sUserName" value={dataSearch.sUserName}
                onChange={onChangeData("sUserName")}
                className="form-control input-sm">
                <option value="">Tất cả</option>
                {listUserName && listUserName.map((user, index) => (
                    <option key={index} value={user.value}>
                        {user.label}
                    </option>
                ))}
            </select>
        </div>
        <div className="input-sm-new input-new-18 search-main-new">
            <button
                type="submit"
                className="btn btn-info-new"
                style={{ marginTop: "28px", paddingTop: "7px" }}
                onClick={onSearch}
            >
                <i className="la la-search"></i>
                <span> &nbsp; Tìm kiếm</span>
            </button>
        </div>
    </div>
);

export default SearchForm;